<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"></a><a id="dedication"></a>When the forms of an old culture are dying,<br/>the new culture is created by a few people who are not afraid<br/>to be insecure.</p>
<p class="author"><strong>Rudolf Bahro</strong></p>
<p class="image1"><img alt="Image" src="images/f00vi-01.jpg"/></p>
<p class="image"><a id="page_vi"></a><img alt="Image" src="images/f0vii-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?7836722d